import clsx from 'clsx';
import React from 'react';
import './Divider.scss';
export const Divider = ({ className }) => React.createElement("div", { className: clsx('form-divider', className) });
